import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import TemplateReviews from '@components/Template/TemplateReviews';

const ReviewsTab: FC = () => {
  return (
    <Box width="100%">
      <TemplateReviews isMobileView={true} showReviewsCount={false} />
    </Box>
  );
};

export default ReviewsTab;
